//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteN from './expedienteMaterias'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteN />
            </div>
        );
    }

}
export default Index;